define('boxes/events/bonus-event',['jquery'], function($) {
    'use strict';

    function changeBonusHandler($controller, $box, bonus) {
        if (bonus === undefined) {
            return;
        }
        $box.find('.selected-bonus').show();
        var $selectedBonusButtons = $box.find('.selected-bonus a');
        var $changeBonusButton = $selectedBonusButtons.find('span.s12-change').parent();
        $changeBonusButton.off('click').on('click', function(e) {
            e.preventDefault();
            $(this).off();
			//clear out the chosen id when going back to carousel
			bonus.depositBonus.model.chosenBonusId = "";
            $controller.goToBox(bonus.depositBonus);
        });
    }

    var bonusEvent = {};
    bonusEvent.BONUS_CHANGED = 'BONUS_CHANGED';
    bonusEvent.NO_SELECTED_BONUS = 'NO_SELECTED_BONUS';
    bonusEvent.RESET_VERIFICATION = 'RESET_VERIFICATION';
    bonusEvent.changeBonusHandler = changeBonusHandler;
    return bonusEvent;
});

